import React from 'react';

import { useBaseOnboardingTemplateQuery } from 'generated/graphql';



export interface IData {
  allAccessEnabled: boolean;
}

export function useQuery() {
  const tuple = useBaseOnboardingTemplateQuery({});

  return React.useMemo(
    () => {
      const data: IData = {
        allAccessEnabled: tuple.data?.allAccessEnabled ?? false
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
